/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */
import Amplify from 'aws-amplify';
import *as awsConfig from "@root-services/aws";

export const amazonCredentiel = () => Amplify.configure(awsConfig.awsConfig);


// WEBPACK FOOTER //
// ./src/root/services/aws-amplify/index.ts